import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as formulaReviewTypes from '../formulaReview/formulaReviewTypes';

const byId = handleActions(
  {
    [formulaReviewTypes.FORMULA_REVIEW_FOR_PRODUCT_LIST.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload.entities.complianceReviews,
    }),
    [formulaReviewTypes.FETCH_FORMULA_REVIEWS.SUCCESS]: (state, { payload }) =>
      (payload.entities && payload.entities.complianceReviews
        ? {
          ...state,
          ...payload.entities.complianceReviews,
        }
        : state),
  },
  {},
);

const allIds = handleActions(
  {
    [combineActions(
      formulaReviewTypes.FORMULA_REVIEW_FOR_PRODUCT_LIST.SUCCESS,
      formulaReviewTypes.FETCH_FORMULA_REVIEWS.SUCCESS,
    )]: (state, { payload }) => {
      if (payload.entities.complianceReviews) {
        return [...new Set([...state, ...Object.keys(payload.entities.complianceReviews).map(Number)])];
      }
      return state;
    },
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
